/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1PersonIdActivateMutationResponse,
  PatchApiV1PersonIdActivatePathParams,
  PatchApiV1PersonIdActivate401,
  PatchApiV1PersonIdActivate404,
  PatchApiV1PersonIdActivate500,
} from "../../types/personRegisterController/PatchApiV1PersonIdActivate.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1PersonIdActivate } from "../../clients/personRegisterController/patchApiV1PersonIdActivate.ts";

export const patchApiV1PersonIdActivateMutationKey = () =>
  [{ url: "/api/v1/person/:id/activate" }] as const;

export type PatchApiV1PersonIdActivateMutationKey = ReturnType<
  typeof patchApiV1PersonIdActivateMutationKey
>;

export function patchApiV1PersonIdActivateMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = patchApiV1PersonIdActivateMutationKey();
  return mutationOptions<
    PatchApiV1PersonIdActivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdActivate401
      | PatchApiV1PersonIdActivate404
      | PatchApiV1PersonIdActivate500
    >,
    { id: PatchApiV1PersonIdActivatePathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return patchApiV1PersonIdActivate(id, config);
    },
  });
}

/**
 * @description Reativa uma pessoa que foi desativada. **(Requer Authorization para autenticação)**
 * @summary Ativar pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/activate}
 */
export function usePatchApiV1PersonIdActivate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1PersonIdActivateMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1PersonIdActivate401
        | PatchApiV1PersonIdActivate404
        | PatchApiV1PersonIdActivate500
      >,
      { id: PatchApiV1PersonIdActivatePathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? patchApiV1PersonIdActivateMutationKey();

  const baseOptions = patchApiV1PersonIdActivateMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiV1PersonIdActivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdActivate401
      | PatchApiV1PersonIdActivate404
      | PatchApiV1PersonIdActivate500
    >,
    { id: PatchApiV1PersonIdActivatePathParams["id"] },
    TContext
  >;

  return useMutation<
    PatchApiV1PersonIdActivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdActivate401
      | PatchApiV1PersonIdActivate404
      | PatchApiV1PersonIdActivate500
    >,
    { id: PatchApiV1PersonIdActivatePathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1PersonIdActivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdActivate401
      | PatchApiV1PersonIdActivate404
      | PatchApiV1PersonIdActivate500
    >,
    { id: PatchApiV1PersonIdActivatePathParams["id"] },
    TContext
  >;
}
